import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-2 sm:pt-2" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "px-2" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_home_latest_videos = _resolveComponent("home-latest-videos")!
  const _component_home_latest_notice = _resolveComponent("home-latest-notice")!
  const _component_home_latest_watch_history = _resolveComponent("home-latest-watch-history")!
  const _component_video_category_list_content = _resolveComponent("video-category-list-content")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_alert, { class: "mt-2 mb-4" }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_home_latest_videos, { videos: _ctx.latestVideos }, null, 8, ["videos"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_home_latest_notice, { notices: _ctx.latestNotices }, null, 8, ["notices"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_home_latest_watch_history, { watchHistories: _ctx.latestWatchHistories }, null, 8, ["watchHistories"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_video_category_list_content, {
                  videoCategories: _ctx.latestVideoCategories,
                  allCategoriesLink: true
                }, null, 8, ["videoCategories"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}